import { forceKeep } from '@weblite/persist'

import * as pvSyncService from '../../logic/pv/offline-sync'
import * as subscriptionSyncService from '../../logic/subscription/offline-sync'
import * as wappRoomService from '../../logic/wapp-room/offline-sync'

/**
 * @note forceKeep is enough for corresponding beforeReduxRehydrate
 * cause these fields are got from server in sync phase
 * followings are going to be sync by different strategies inside their own services
 */
export async function beforeReduxRehydrate() {
  await Promise.all([
    pvSyncService.getIds().then(items => forceKeep('pvs', items)),
    wappRoomService.getIds().then(items => forceKeep('wappRooms', items)),
    // prettier-ignore
    subscriptionSyncService.getIds().then(items => forceKeep('subscriptions', items)),
  ])
}
